import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type { ModelId } from '@/lib/constants'

export interface AIModel {
  id: ModelId
  name: string
  description: string
  isDefault: boolean
}

export function useModels() {
  return useQuery({
    queryKey: ['models'],
    queryFn: () => api.get<AIModel[]>('/generate/models'),
    staleTime: 1000 * 60 * 60,
  })
}
